import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { MetaDrivenTable, PaginationControls } from "../../../shared/components";
import { formatCurrency } from "../../../shared/utils";
import { useForecast } from "../hooks/useForecast";

export const Forecast: React.FC<{ projectId: string | undefined }> = ({ projectId }) => {

    const { isLoading, isError, error, data, pagination, changePage, changeRowsPerPage } = useForecast(projectId);

    const headers = [
        { "alias_name": "forecast_type", "label": "Forecast Type", "is_editiable": false, "domain": "", "display_order": 1, "is_show": true, "is_export": null },
        { "alias_name": "period", "label": "Period", "is_editiable": false, "domain": "", "display_order": 2, "is_show": true, "is_export": null },
        { "alias_name": "forecast_value", "label": "Forecast Value", "is_editiable": false, "domain": "", "display_order": 3, "is_show": true, "is_export": null, "style": { textAlign: 'right' } },
        { "alias_name": "cumulative_forecast", "label": "Cumulative Forecast", "is_editiable": false, "domain": "", "display_order": 4, "is_show": true, "is_export": null, "style": { textAlign: 'right' } },
        { "alias_name": "variance_to_baseline", "label": "Variance to Baseline", "is_editiable": false, "domain": "", "display_order": 5, "is_show": true, "is_export": null, "style": { textAlign: 'right' } },
        { "alias_name": "project_ref", "label": "Project ref", "is_editiable": false, "domain": "", "display_order": 6, "is_show": false, "is_export": null },
        { "alias_name": "budget_ref", "label": "Budget ID", "is_editiable": false, "domain": "", "display_order": 7, "is_show": false, "is_export": null },
    ];

    const metrics = {
        "cumulative_forecast": {
            type: "component",
            style: { textAlign: 'right' },
            element: (row: { cumulative_forecast: string }) => formatCurrency(Number(row.cumulative_forecast))
        },
        "forecast_value": {
            type: "component",
            style: { textAlign: 'right' },
            element: (row: { forecast_value: string }) => formatCurrency(Number(row.forecast_value))
        },
        "variance_to_baseline": {
            style: { textAlign: 'right' }
        }
    };

    if (isLoading) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
            >
                <CircularProgress />
            </Box>
        )
    };

    return (
        <Box flex={1} height={'100%'} display={'flex'} flexDirection={'column'}>
            <Box flex={1} sx={{ overflowX: "hidden", overflowY: "auto" }}>
                <MetaDrivenTable headers={headers} data={data} dataMetrics={metrics} sortDisabled={true} />
            </Box>
            <Box flexShrink={0}>
                <PaginationControls
                    total={pagination?.total}
                    rowsPerPage={pagination?.limit}
                    currentPage={pagination?.page}
                    handleRowsPerPage={changeRowsPerPage}
                    handlePageChange={changePage}
                />
            </Box>
        </Box>
    );

};